import Cookies from 'universal-cookie';
import moment from 'moment';
const cookies = new Cookies();

export default class Session {

	static setCookie(cname, cvalue) {
		let expires = new Date(moment().add(3, "d"));
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	static setPersistentCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + window.btoa(JSON.stringify(cvalue)) + ";" + expires + ";path=/";
	}
	
	static set(cookie, data, type = 'session'){
		if (type ==='session'){
			/**set data into session storage */
			sessionStorage.setItem(cookie, window.btoa(JSON.stringify(data)));
		} else if (type === 'localstorage') {
			/**set data into local storage */
			localStorage.setItem(cookie, window.btoa(JSON.stringify(data)));
		} else{
			/** set data into cookies */
			if(typeof data === 'string'){
				this.setCookie(cookie, window.btoa(data));
			}else{
				this.setCookie(cookie, window.btoa(JSON.stringify(data)));
			}
		}

		return true;
	}

	static get(cookie, type = 'session'){
		let data;

		if (type === 'session') {
			/** get data from session storage */
			data = sessionStorage.getItem(cookie);
		} else if (type === 'localstorage') {
			/** get data from local storage */
			data = localStorage.getItem(cookie);
		} else{
			/** get data from cookies */
			data = cookies.get(cookie);
			
		}

		try {
			return data ? JSON.parse(window.atob(data)) : '';	
		} catch (error) {
			return data ? window.atob(data) : '';
		}
		
		
	}

	static clear(cookie, type = 'session'){
		if (type === 'session') {
			/** remove data from session storage */
			sessionStorage.removeItem(cookie);
		} else if (type === 'localstorage') {
			/** remove data from session storage */
			localStorage.removeItem(cookie);
		} else{
			/** remove data from cookies */
			cookies.remove(cookie);
		}

		return true;
	}

	static clr(cookie){
		document.cookie = cookie+'=; path=/; domain=.yanmar.co.in; expires=' + new Date(0).toUTCString();
	}
}